module.exports = __webpack_public_path__ + "assets/img/index_plat_two.b8996dab.png";